// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/iam/v1/iam.proto" (package "c1.api.iam.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * Role is a role that can be assigned to a user in ConductorOne.
 *
 * @generated from protobuf message c1.api.iam.v1.Role
 */
export interface Role {
    /**
     * The id of the role.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the Role was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Role was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Role was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4;
     */
    deletedAt?: Timestamp;
    /**
     * The system builtin field. If this field is set, the role is not editable.
     *
     * @generated from protobuf field: bool system_builtin = 5;
     */
    systemBuiltin: boolean;
    /**
     * The internal name of the role.
     *
     * @generated from protobuf field: string name = 6;
     */
    name: string;
    /**
     * The display name of the role.
     *
     * @generated from protobuf field: string display_name = 7;
     */
    displayName: string;
    /**
     * The list of serviceRoles that this role has.
     *
     * @generated from protobuf field: repeated string service_roles = 8;
     */
    serviceRoles: string[];
    /**
     * The list of permissions this role has.
     *
     * @generated from protobuf field: repeated string permissions = 9;
     */
    permissions: string[];
    /**
     * This Role is intended for API keys usage only, and the user interface may not function as expected.
     *
     * @generated from protobuf field: bool system_api_only = 10;
     */
    systemApiOnly: boolean;
}
/**
 * ServiceRole is a container for permissions referenced by Role.
 *
 * @generated from protobuf message c1.api.iam.v1.ServiceRole
 */
export interface ServiceRole {
    /**
     * The id of the role.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The list of permissions this role has.
     *
     * @generated from protobuf field: repeated c1.api.iam.v1.ServicePermission permissions = 9;
     */
    permissions: ServicePermission[];
}
/**
 * ServicePermission is an individual permission granted by a Role or ServiceRole.
 *
 * @generated from protobuf message c1.api.iam.v1.ServicePermission
 */
export interface ServicePermission {
    /**
     * The id of the permission.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * The GetRolesResponse message contains the retrieved role.
 *
 * @generated from protobuf message c1.api.iam.v1.GetRolesResponse
 */
export interface GetRolesResponse {
    /**
     * The role object.
     *
     * @generated from protobuf field: c1.api.iam.v1.Role role = 1;
     */
    role?: Role;
}
/**
 * @generated from protobuf message c1.api.iam.v1.GetRolesRequest
 */
export interface GetRolesRequest {
    /**
     * @generated from protobuf field: string role_id = 1;
     */
    roleId: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ListRolesRequest
 */
export interface ListRolesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * UpdateRolesResponse is the response message containing the updated role.
 *
 * @generated from protobuf message c1.api.iam.v1.UpdateRolesResponse
 */
export interface UpdateRolesResponse {
    /**
     * The role that has been updated.
     *
     * @generated from protobuf field: c1.api.iam.v1.Role role = 1;
     */
    role?: Role;
}
/**
 * The UpdateRoleRequest message contains the role to update and the update mask.
 *
 * @generated from protobuf message c1.api.iam.v1.UpdateRoleRequest
 */
export interface UpdateRoleRequest {
    /**
     * The role object that contains the updated values.
     *
     * @generated from protobuf field: c1.api.iam.v1.Role role = 1;
     */
    role?: Role;
    /**
     * An UpdateMask, letting you set a comma-separated list of strings of what fields to update.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * The ListRolesResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.iam.v1.ListRolesResponse
 */
export interface ListRolesResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.iam.v1.Role list = 1;
     */
    list: Role[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.RoleBinding
 */
export interface RoleBinding {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string user_id = 8;
     */
    userId: string;
    /**
     * @generated from protobuf field: string role_id = 9;
     */
    roleId: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ListRoleBindingsRequest
 */
export interface ListRoleBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf oneof: filter
     */
    filter: {
        oneofKind: "userId";
        /**
         * @generated from protobuf field: string user_id = 3;
         */
        userId: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.iam.v1.ListRoleBindingsResponse
 */
export interface ListRoleBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.iam.v1.RoleBinding list = 1;
     */
    list: RoleBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.CreateRoleBindingsRequest
 */
export interface CreateRoleBindingsRequest {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: string role_id = 2;
     */
    roleId: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.DeleteRoleBindingsRequest
 */
export interface DeleteRoleBindingsRequest {
    /**
     * @generated from protobuf field: string role_binding_id = 1;
     */
    roleBindingId: string;
    /**
     * @generated from protobuf field: string role_id = 2;
     */
    roleId: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.SearchRolesRequest
 */
export interface SearchRolesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_role_ids = 4;
     */
    excludeRoleIds: string[];
    /**
     * @generated from protobuf field: repeated string role_ids = 5;
     */
    roleIds: string[];
}
/**
 * @generated from protobuf message c1.api.iam.v1.SearchRolesResponse
 */
export interface SearchRolesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.iam.v1.Role list = 1;
     */
    list: Role[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Role$Type extends MessageType<Role> {
    constructor() {
        super("c1.api.iam.v1.Role", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "system_builtin", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 8, name: "service_roles", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "256", items: { string: { minBytes: "1", maxBytes: "512" } } } } } },
            { no: 9, name: "permissions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "256", items: { string: { minBytes: "1", maxBytes: "512" } } } } } },
            { no: 10, name: "system_api_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ], { "policy.v1.msg": { enabled: true, name: "role", keyFields: ["id"] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.Role
 */
export const Role = new Role$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceRole$Type extends MessageType<ServiceRole> {
    constructor() {
        super("c1.api.iam.v1.ServiceRole", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "permissions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServicePermission, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "256" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ], { "policy.v1.msg": { enabled: true, name: "service_role", keyFields: ["id"] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ServiceRole
 */
export const ServiceRole = new ServiceRole$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServicePermission$Type extends MessageType<ServicePermission> {
    constructor() {
        super("c1.api.iam.v1.ServicePermission", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ], { "policy.v1.msg": { enabled: true, name: "service_permission", keyFields: ["id"] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ServicePermission
 */
export const ServicePermission = new ServicePermission$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRolesResponse$Type extends MessageType<GetRolesResponse> {
    constructor() {
        super("c1.api.iam.v1.GetRolesResponse", [
            { no: 1, name: "role", kind: "message", T: () => Role }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.GetRolesResponse
 */
export const GetRolesResponse = new GetRolesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRolesRequest$Type extends MessageType<GetRolesRequest> {
    constructor() {
        super("c1.api.iam.v1.GetRolesRequest", [
            { no: 1, name: "role_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.GetRolesRequest
 */
export const GetRolesRequest = new GetRolesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRolesRequest$Type extends MessageType<ListRolesRequest> {
    constructor() {
        super("c1.api.iam.v1.ListRolesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ListRolesRequest
 */
export const ListRolesRequest = new ListRolesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRolesResponse$Type extends MessageType<UpdateRolesResponse> {
    constructor() {
        super("c1.api.iam.v1.UpdateRolesResponse", [
            { no: 1, name: "role", kind: "message", T: () => Role }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.UpdateRolesResponse
 */
export const UpdateRolesResponse = new UpdateRolesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRoleRequest$Type extends MessageType<UpdateRoleRequest> {
    constructor() {
        super("c1.api.iam.v1.UpdateRoleRequest", [
            { no: 1, name: "role", kind: "message", T: () => Role, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.UpdateRoleRequest
 */
export const UpdateRoleRequest = new UpdateRoleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRolesResponse$Type extends MessageType<ListRolesResponse> {
    constructor() {
        super("c1.api.iam.v1.ListRolesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Role },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ListRolesResponse
 */
export const ListRolesResponse = new ListRolesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RoleBinding$Type extends MessageType<RoleBinding> {
    constructor() {
        super("c1.api.iam.v1.RoleBinding", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "role_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.RoleBinding
 */
export const RoleBinding = new RoleBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRoleBindingsRequest$Type extends MessageType<ListRoleBindingsRequest> {
    constructor() {
        super("c1.api.iam.v1.ListRoleBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "user_id", kind: "scalar", oneof: "filter", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ListRoleBindingsRequest
 */
export const ListRoleBindingsRequest = new ListRoleBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRoleBindingsResponse$Type extends MessageType<ListRoleBindingsResponse> {
    constructor() {
        super("c1.api.iam.v1.ListRoleBindingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RoleBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ListRoleBindingsResponse
 */
export const ListRoleBindingsResponse = new ListRoleBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRoleBindingsRequest$Type extends MessageType<CreateRoleBindingsRequest> {
    constructor() {
        super("c1.api.iam.v1.CreateRoleBindingsRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "role_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.CreateRoleBindingsRequest
 */
export const CreateRoleBindingsRequest = new CreateRoleBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRoleBindingsRequest$Type extends MessageType<DeleteRoleBindingsRequest> {
    constructor() {
        super("c1.api.iam.v1.DeleteRoleBindingsRequest", [
            { no: 1, name: "role_binding_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "role_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.DeleteRoleBindingsRequest
 */
export const DeleteRoleBindingsRequest = new DeleteRoleBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRolesRequest$Type extends MessageType<SearchRolesRequest> {
    constructor() {
        super("c1.api.iam.v1.SearchRolesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.SearchRolesRequest
 */
export const SearchRolesRequest = new SearchRolesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRolesResponse$Type extends MessageType<SearchRolesResponse> {
    constructor() {
        super("c1.api.iam.v1.SearchRolesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Role },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.SearchRolesResponse
 */
export const SearchRolesResponse = new SearchRolesResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.iam.v1.RoleBindings
 */
export const RoleBindings = new ServiceType("c1.api.iam.v1.RoleBindings", [
    { name: "Create", options: { "authz.method": { role: "OWNER" } }, I: CreateRoleBindingsRequest, O: RoleBinding },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ListRoleBindingsRequest, O: ListRoleBindingsResponse },
    { name: "Delete", options: { "authz.method": { role: "OWNER" } }, I: DeleteRoleBindingsRequest, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service c1.api.iam.v1.Roles
 */
export const Roles = new ServiceType("c1.api.iam.v1.Roles", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/iam/roles/{role_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Role", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Role" }] } }, I: GetRolesRequest, O: GetRolesResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/iam/roles/{role.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Role" }], group: "Role" }] } }, I: UpdateRoleRequest, O: UpdateRolesResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/iam/roles", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Role", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Roles", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Role", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: ListRolesRequest, O: ListRolesResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.iam.v1.RoleSearch
 */
export const RoleSearch = new ServiceType("c1.api.iam.v1.RoleSearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchRolesRequest, O: SearchRolesResponse }
]);
